import { ReactElement } from 'react';
import { CalculatedCellValue } from '../types';
import { PersonalLoanCell } from './PersonalLoanCell';
import { PriceCell } from './PriceCell';

/**
 * Which cell draws a calculated value, by provider. `satisfies never` keeps it
 * total: a provider with no cell here does not compile.
 */
export const renderCalculatedCell = (
  value: CalculatedCellValue,
): ReactElement | null => {
  switch (value.provider) {
    case 'TI_QUOTE':
      return <PriceCell result={value.result} />;

    case 'PL_CALCULATOR':
      return <PersonalLoanCell data={value} />;

    default:
      // Unknown provider renders nothing rather than crashing the table.
      value satisfies never;
      return null;
  }
};
